import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    login: false,
    menuList: [
      {
        cd: "0",
        text: "",
        icon: "",
        menu: false,
        children: [
          {
            cd: "6-1",
            text: "点字サークル「杉」",
            drawerText: "HOME",
            subText: "埼玉県北葛飾郡杉戸町",
            url: "/",
            image: "greenPhoto1.jpg",
            icon: "",
          },
        ],
      },
      {
        cd: "1",
        text: "点字サークル「杉」とは",
        icon: "",
        menu: true,
        children: [
          {
            cd: "1-1",
            text: "点字サークル「杉」とは",
            drawerText: "点字サークル「杉」とは",
            url: "/about",
            image: "greenPhoto3.jpg",
            icon: "",
          },
          {
            cd: "1-2",
            text: "これまでの「杉」のあゆみ",
            drawerText: "これまでの「杉」のあゆみ",
            url: "/histry",
            image: "greenPhoto6.jpg",
            icon: "",
          },
        ],
      },
      {
        cd: "2",
        text: "点訳図書",
        icon: "",
        menu: true,
        children: [
          {
            cd: "2-1",
            text: "点訳図書を読む",
            drawerText: "点訳図書を読む",
            url: "/library",
            image: "greenPhoto9.jpg",
            icon: "",
          },
          {
            cd: "2-2",
            text: "点訳を依頼する",
            drawerText: "点訳を依頼する",
            url: "/request",
            image: "greenPhoto5.jpg",
            icon: "",
          },
        ],
      },
      {
        cd: "3",
        text: "活動内容",
        icon: "",
        menu: true,
        children: [
          {
            cd: "3-1",
            text: "写真",
            drawerText: "写真",
            url: "/photo",
            image: "greenPhoto2.jpg",
            icon: "",
          },
          {
            cd: "3-2",
            text: "ブログ",
            drawerText: "ブログ",
            url: "http://sugi102.blog102.fc2.com/",
            image: "",
            icon: "",
          },
        ],
      },
      {
        cd: "4",
        text: "その他",
        icon: "",
        menu: false,
        children: [
          {
            cd: "4-1",
            text: "お問い合わせ",
            drawerText: "お問い合わせ",
            url: "http://form1.fc2.com/form/?id=745256",
            image: "greenPhoto8.jpg",
            icon: "",
          },
          // {
          //   cd: "4-2",
          //   text: "お知らせ",
          //   drawerText: "お知らせ",
          //   url: "/news",
          //   image: "greenPhoto4.jpg",
          //   icon: "",
          // },
        ],
      },
    ],
  },
  mutations: {},
  actions: {},
  modules: {},
});
